<script>
import DropZone from "@/components/widgets/dropZone2";
import _ from "lodash";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    inputFileId: {
      type: String,
      default: "dropzoneFile",
    },
    showFileList: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  emits: ["changed"],
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    drop(e) {
      const files = e.dataTransfer.files;
      this._changed(files, "add");
    },
    selectedFile() {
      const files = document.querySelector("#" + this.inputFileId).files;
      this._changed(files, "add");
    },
    deleteFile(index) {
      this.fileList.splice(index, 1);
      this._changed(this.files[index], "delete");
    },
    _changed(file, type) {
      this.$emit("changed", file, type);
    },
  },
  watch: {
    files: {
      immediate: true,
      deep: true,
      handler(newV) {
        this.fileList = _.cloneDeep(newV);
      },
    },
  },
  components: {
    DropZone,
  },
};
</script>
<template>
  <div>
    <label class="form-label">{{ title }}</label>
    <p class="text-muted">{{ description }}</p>
    <DropZone
      :input-file-id="inputFileId"
      @drop.prevent="drop"
      @change="selectedFile"
    />
    <div v-if="showFileList">
      <div
        class="border rounded"
        v-for="(file, index) of fileList"
        :key="index"
      >
        <div class="d-flex align-items-center p-2">
          <div class="flex-grow-1">
            <div class="pt-1">
              <h5 class="fs-14 mb-1" data-dz-name="">
                {{ file.name }}
              </h5>
              <p class="fs-13 text-muted mb-0" data-dz-size="">
                <strong>{{ (file.size / 1024).toFixed(2) }}</strong> KB
              </p>
              <strong
                class="error text-danger"
                data-dz-errormessage=""
              ></strong>
            </div>
          </div>
          <div class="flex-shrink-0 ms-3">
            <b-button
              data-dz-remove=""
              variant="danger"
              size="sm"
              @click="deleteFile(index)"
            >
              {{ $t("base.delete") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
